<div class="ir-login-image-wrapper">
  <img class="ir-login-image" src="../../assets/img/logo.svg" alt="Logo" width="150" />
</div>
<div class="container">
  <div class="row justify-content-center">
    <div class="card login-card-wrapper">
      <div class="card-header">
        <h3>{{ 'LOGIN.RESET_PASSWORD' | translate }}</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="passwordForm">
          <div class="form-group">
            <label for="newPassword">{{ 'LOGIN.NEW_PASSWORD' | translate }}</label>
            <input
              type="password"
              id="newPassword"
              placeholder="{{ 'LOGIN.NEW_PASSWORD' | translate }}"
              formControlName="password"
              required
              class="login-username" />
            <small *ngIf="passwordControl.invalid">{{ 'ADMINISTRATION.VALIDATIONS.PASSWORD_REQUIREMENTS' | translate }}</small>
            <div class="error fw-bold">
              {{ getPasswordErr() }}
            </div>
          </div>

          <div class="form-group">
            <label for="password">{{ 'LOGIN.REPEAT_PASSWORD' | translate }}</label>
            <div class="input-group password-wrapper">
              <input
                class="form-control login-username"
                id="password"
                type="password"
                placeholder="{{ 'LOGIN.REPEAT_PASSWORD' | translate }}"
                formControlName="confirmPassword"
                required
                (focus)="onFocus()" />
            </div>
            <div class="error fw-bold">
              {{ getConfirmPwdErr() }}
            </div>
          </div>

          <div class="form-actions">
            <button class="form-control form-control-lg" [disabled]="passwordForm.invalid" type="button" (click)="reset()">
              {{ 'LOGIN.RESET_PASSWORD' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
